import RegisterForm from '~/components/auth/RegisterForm';
import FormInput from '~/components/form/TextInput.vue';
import Checkbox from '~/components/form/Checkbox';
export default {
  components: {
    RegisterForm: RegisterForm,
    FormInput: FormInput,
    Checkbox: Checkbox
  },
  data: function data() {
    return {
      sent: false,
      email: ''
    };
  },
  computed: {
    authPanelStore: function authPanelStore() {
      return useAuthPanelStore();
    },
    appStore: function appStore() {
      return useAppStore();
    }
  },
  methods: {
    onDone: function onDone(email) {
      this.email = email;
      this.sent = true;
    },
    changePanel: function changePanel() {
      this.authPanelStore.$patch({
        direction: 'right',
        state: 'login'
      });
    },
    resend: function resend() {
      var _this = this;
      this.$axios.post("/tempUser/resendverificaion/", {
        _csfr: this.appStore.csrfToken,
        email: this.email
      }).then(function () {
        var toast = {
          title: _this.$t('confirmEmail.sentTitle'),
          text: _this.$t('confirmEmail.resentText'),
          icon: 'icon-ic-tick'
        };
        _this.$toastStore.add(toast);
      }).catch(function (error) {
        var res = error.response ? error.response.data : null;
        var toast = {
          title: _this.$t('passwordRecover.resentTitleError'),
          text: _this.$t('passwordRecover.resentTextError'),
          icon: 'icon-ic-dismiss'
        };
        if (res) toast.text = res;
        _this.$toastStore.add(toast);
      });
    }
  }
};